import moment from "moment";

export const addOrSubtractFromDate = (date, difference, unit = "days") => {
  if (difference > 0) {
    return moment(date).add(difference, unit);
  } else {
    return moment(date).subtract(Math.abs(difference), unit);
  }
};

export const getDifferenceBetweenDates = (date1, date2) => {
  return moment(date1).diff(moment(date2), "days");
};

export const isMomentObject = (value) => {
  return moment.isMoment(value);
};

export const momentToDate = (value) => {
  return moment(value).toDate();
};

export const dateToMoment = (value) => {
  return moment(value);
};

export const dateInRangeIncludesStart = (date, start, end) => {
  return (
    moment(date).isBetween(moment(start), moment(end)) ||
    moment(date).isSame(moment(start))
  );
};
